// @ts-nocheck

/**
 * * `background` - Background
 * `image` - Image
 */
export type ImageAssetTypeEnum =
  typeof ImageAssetTypeEnum[keyof typeof ImageAssetTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageAssetTypeEnum = {
  background: "background",
  image: "image",
} as const;
